module.exports = __webpack_public_path__ + "media/images/athletes/2833-1b38612c6aa6fbe5c9ad931126ef9f4a.png";